import { render } from "./QuestionCard.vue?vue&type=template&id=cbab39b2"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"

import "./QuestionCard.vue?vue&type=style&index=0&id=cbab39b2&lang=css"
import "./QuestionCard.vue?vue&type=style&index=1&id=cbab39b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__